import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../grid/grid';
import '../interactions/interactions';
import '../rule/rule';
import '../typography/typography';
import css from './emphasised-link.css';

const EmphasisedLink = React.forwardRef(
  ({ text, href, className, variant, inverse, ...otherProps }, ref) => (
    <a
      ref={ref}
      className={classnames(
        css['ds-emphasised-link'],
        {
          [css['ds-emphasised-link--inverse']]: inverse,
          [css[`ds-emphasised-link--${variant}`]]: variant,
        },
        className,
      )}
      href={href}
      {...otherProps}
    >
      <span>{text}</span>
    </a>
  ),
);

EmphasisedLink.displayName = 'EmphasisedLink';

EmphasisedLink.defaultProps = {
  className: '',
  inverse: false,
  href: '',
  variant: null,
};

EmphasisedLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['secondary']),
  inverse: PropTypes.bool,
};

export default EmphasisedLink;
